module.exports = __webpack_public_path__ + "img/briefcase.1f2061a6.svg";